import { Component, OnInit, Inject } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { NotificationService } from '../../../../../core/services/notification/notification.service';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog'
import { TransactionResult } from '../../../../../core/services/interfaces/transaction-result';
import { IProjects } from '../../Interfaces/IProjects';
import { ProjectsService } from '../../services/projects-services';
import { TranslateApplicationService } from '../../../../../core/translate/translate-application-service';
import { BuildingsService } from '../../services/buildings-services';
import { IBuildings } from '../../Interfaces/IBuildings';

declare var $: any;

interface Building {
	label: String;
	value: {
		building: String;
		pkbuilding: number;
	};
}

interface BuildingValues {
  building: string;
  pkbuilding: number;
}

@Component({
  selector: 'project-detail',
  templateUrl: 'project-detail.html',
  styleUrls: ['project-detail.scss']
})

export class ProjectDetail {
  formGroup: FormGroup;
  loading = false;
  max_characters: string = "";
  listBuildings:  Building[] = [];
  selectedBuildings: Building[];
  display: boolean = true;

  constructor(
    private dialogRef: MatDialogRef<ProjectDetail>,
    @Inject(MAT_DIALOG_DATA) public data: IProjects,
    private notificationService: NotificationService,
    private projectService: ProjectsService,
    private formBuilder: FormBuilder,
    public translate: TranslateApplicationService,
    private buildingsService: BuildingsService,
  ) {
    this.formGroup = this.formBuilder.group({
      pkproject: [data.pkproject == null ? 0 : data.pkproject],
      txtproject: [
        data.project,
        [
          Validators.required,
          Validators.maxLength(255),
          Validators.pattern('.*[a-zA-Z].*')
        ]
      ],
      cbbuildings: [this.selectedBuildings, Validators.required],
    });
  }

  ngOnInit() {
    let max_char = this.translate.TranslateKey('max_characteres');
		this.max_characters = max_char.replace('{{ number_max }}', '255');
    this.GetBuildings();
    if(this.data.pkproject != 0){
      this.GetBuildingsByPkProject();
    }
  }

  GetBuildingsByPkProject()
  {
    this.loading = true;
    this.buildingsService.GetBuildingsByPkProject(this.formGroup.controls.pkproject.value).subscribe(
    (result: TransactionResult<IBuildings[]>) => {
      if(result.success){
        let buildings: BuildingValues[] = [];
        result.data.forEach(obj=>{
          if (obj.available) {
            let building: BuildingValues = {
              pkbuilding: obj.pkbuilding,
              building: obj.building
            };
            buildings.push(building);
          }
        });
        this.formGroup.controls.cbbuildings.setValue(buildings);
        this.loading = false;
      }
      else{
        this.loading = false;
        this.ErrorAlert(result.messages);
      }
    },
    (error) => {
      this.loading = false;
    });
  }

  GetBuildings(){
    this.loading = true;
    this.buildingsService.GetAvailableBuildings().subscribe(
    (result: TransactionResult<IBuildings[]>) =>{
      if(result.success){
        this.listBuildings = [];
        result.data.forEach(obj=>{
          this.listBuildings.push({
            label: obj.building,
            value: {
              building: obj.building,
              pkbuilding: obj.pkbuilding,
            }, 
          });
        });
        this.loading = false;
      }
      else{
        this.ErrorAlert(result.message);
        this.loading = false;
      }
    },
    (error) => 
    {
      this.ErrorAlert(error);
      this.loading = false;
    });
  }
  
  Save() {
    this.loading = true;
    if (this.formGroup.valid) {
      if (this.formGroup.controls.pkproject.value == 0) {
        this.projectService.CreateProject(this.formGroup.value).subscribe(
        (result: TransactionResult<IProjects[]>) => {
          
          if (result) { 
            
                this.Alert();
                this.loading = false;
                this.dialogRef.close(true);
              
          }
          else{
            this.loading = false;
          }
        },
        (error: any) => { 
          this.ErrorAlert(error); this.loading = false; 
        });
      }
      else {
        this.projectService.UpdateProject(this.formGroup.value).subscribe(
        (result: TransactionResult<boolean>) => {
          this.loading = false;
          if (result) { 
            
                this.Alert();
                this.dialogRef.close(true); 
            
          }
        },
        (error: any) => { 
          this.ErrorAlert(error); this.loading = false; 
        });
      }
    }
    else{
      this.loading = false;
      this.notificationService.AddAlert({
        icon: 'all_inbox',
        title: 'Warning',
        message: this.translate.TranslateKey('COMPLETE_FORM'),
        shown: true
      });
    }
  }


  Close() {
    this.dialogRef.close(false);
  }

  Alert() {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Success',
      message: this.translate.TranslateKey('COMPLETE'),
      shown: true
    });

  }

  ErrorAlert(message: any) {
    this.notificationService.AddAlert({
      icon: 'all_inbox',
      title: 'Error',
      message: message,
      shown: true,
    });
  }
}
